









import Vue from 'vue'
import { Button } from 'element-ui'
import './EndSession.scss'

export default Vue.extend({
  name: 'EndSession',
  created () {
    this.logout()
  },
  methods: {
    logout () {
      this.$store.direct.dispatch.user.logoutUser()
    },
    navigateTo (name) {
      this.$router.push({ name })
    }
  },
  components: {
    'el-button': Button
  }
})

